import { Component, OnDestroy } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'boxx-custom-time-popover',
  templateUrl: './custom-time-popover.component.html',
  styleUrls: ['./custom-time-popover.component.scss'],
})
export class CustomTimePopoverComponent implements OnDestroy {
  public maxDate = (Number(new Date().getFullYear()) + 1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = 'date-time';
  public paramPres: string;
  public currentDate: string;

  public modalType = 1;
  minInsterval: number[];

  constructor(private modalCtrl: PopoverController) { }

  ngOnInit() {
    const minT = 0,
      maxT = 55,
      interval = 5;

    const length = (maxT - minT) / interval + 1;
    this.minInsterval = Array.from({ length }, (_, i) => minT + i * interval);
    this.currentDate = moment().add(1, 'days').format('YYYY-MM-DD') + 'T01:01:01-01:00';
    this.defaultDate = this.currentDate;
    this.getLanguageApp();
    if (this.paramPres) {
      this.customPres = this.paramPres;
    }
  }

  async getLanguageApp() {
    this.localeString = 'en-US';
  }

  ngOnDestroy() { }

  async close() {
    this.modalCtrl.dismiss();
  }

  selectDate() {
    this.modalCtrl.dismiss({
      cDate: this.defaultTime //+ 'T12:01:01-12:00'
    });
  }

}
